import { column, Table, useGrid } from "@podtrac/common/grid";
import { NavLink, useLocation, useParams } from "react-router-dom";
import styles from "../rankings.module.scss";
import { useShowRankingsAppleDetail } from "../rankings-api";
import DailyRankChart from "../daily-rank-chart";
import { useMemo } from "react";
import { CountryCell } from "./country-cell";
import { SortButton } from "../sort-button";
import { Elide, ElideCell } from "./elide";

export function ShowRankingsAppleDetail() {
    const { accountID, showID, iTunesID, iTunesCode, countryCode } = useParams();
    const {
        state: { month },
    } = useLocation();
    const query = useShowRankingsAppleDetail(
        accountID,
        showID,
        iTunesID,
        iTunesCode,
        countryCode
    );
    const grid = useGrid({
        data: query.data,
        enableSorting: true,
        columns,
        defaultColumn: {
            headerAlign: "center",
            header: SortButton,
        },
    });

    const { category, subcategory, country } = query.data?.[0] ?? {};

    const chartData = useMemo(() => query.data?.toReversed(), [query.data]);

    return (
        <>
            <header className={styles.header}>
                <h1>
                    <NavLink to={`../apple${month ? "/" + month : ""}`}>
                        Apple Podcasts Rankings
                    </NavLink>
                    <span style={{ opacity: 0.5 }}>·</span>
                    <span>{category ? category + (subcategory ? "/" + subcategory : "") + ", " + country : null}</span>
                </h1>

                <button
                    type="button"
                    onClick={grid.exportCsv(
                        `Apple Podcasts Rankings-${category}${subcategory ? "-" + subcategory : ""}-${country}.csv`
                    )}
                >
                    Export
                </button>
            </header>
            <DailyRankChart data={chartData} />
            <Table grid={grid} className={styles.grid} />
            {/*<pre>{JSON.stringify(query, null, 2)}</pre>*/}
        </>
    );
}

const columns = [
    column.accessor("date", {
        id: "Date",
        align: "center",
        cell: DateCell,
    }),
    column.accessor("title", {
        id: "Title",
        align: "left",
        cell: ElideCell,
    }),
    column.accessor("category", {
        id: "Category",
        align: "left",
        cell: CategoryCell,
    }),
    column.accessor("subcategory", {
        id: "Subcategory",
        align: "left",
        hidden: true,
    }),
    column.accessor("country", {
        id: "Country",
        align: "left",
        cell: CountryCell,
    }),
    column.accessor("rank", {
        id: "Rank",
        align: "center",
        cell: RankCell,
    }),
];

function DateCell({ getValue }) {
    return getValue().substring(0, 10);
}

function CategoryCell({ row }) {
    const { category, subcategory } = row.original;
    return <Elide>{category + (subcategory ? "/" + subcategory : "")}</Elide>;
}

const deltaFormat = Intl.NumberFormat(undefined, {
    signDisplay: "always",
}).format;
function RankCell({ row }) {
    const { rank, deltaRank } = row.original;
    const pos = deltaRank > 0;
    return (
        <div className={styles.rank}>
            <small></small>
            <span>{rank}</span>
            <small className={pos ? styles.pos : styles.neg}>
                {deltaRank ? deltaFormat(deltaRank) : null}
            </small>
        </div>
    );
}
